import { formatters } from "@/helpers/formatters";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  {
    title: "B2B / B2C",
    value: "b2b_b2c",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Business Goal",
    value: "business_goal",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Campaign KPI",
    value: "campaign_kpi",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel",
    value: "channel",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel Objective",
    value: "channel_objective",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Funnel Stage",
    value: "funnel_stage",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Media Type",
    value: "media_type",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
];
